module.exports = __webpack_public_path__ + "bear.c243533.jpg";